module.exports = __webpack_public_path__ + "1d11241174da5c8b002f0d55e06997a3.svg";